import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, inject, Signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { select } from '@ngxs/store';
import { BusinessServices, IUser } from '@shs-digi-care-monorepo/interfaces';
import packageJson from 'package.json';
import { ContactDialog } from './components/contact-dialog/contact-dialog.component';
import { BaseHeaderComponent } from '@shs-digi-care-monorepo/frontend-lib/components';
import { UserState } from '@shs-digi-care-monorepo/frontend-lib/states';
import { SettingsMenuComponent } from './components/settings-menu/settings-menu.component';
import { NamFeature, NamFeatureService } from '../../services/nam-feature.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    imports: [TranslateModule, RouterModule, BaseHeaderComponent, SettingsMenuComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HeaderComponent {
    private dialog = inject(MatDialog);
    private readonly features = inject(NamFeatureService);

    protected version = packageJson.version;
    protected me: Signal<IUser | null> = select(UserState.me);
    protected isAdmin: Signal<boolean> = this.features.isEnabled(NamFeature.ADMIN_AREA);
    protected isInternalUser: Signal<boolean> = this.features.isInternal;

    protected userName = computed(() => {
        const user = this.me();
        return user ? `${user.firstName} ${user.lastName}` : null;
    });

    protected userInfo = computed(() => {
        const user = this.me();
        return user?.userRoles
            ? user.userRoles
                  .filter((userRole) => userRole.role.stream === BusinessServices.OM_NAM)
                  .map((userRole) => userRole.role.name)
                  .join(', ')
            : '';
    });

    protected userInitials = computed(() => {
        const user = this.me();
        return user ? `${user.firstName.charAt(0)}${user.lastName.charAt(0)}` : null;
    });

    public openContactDialog(): void {
        this.dialog.open(ContactDialog);
    }
}
